import React, { useContext } from 'react';
import { Image } from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { AppContext } from 'contexts/AppContext';

const Hero = () => {
  const {
    marketingInfo: { propertyLogoLink },
  } = useContext(AppContext);

  return (
    <Image
      src={propertyLogoLink}
      height={96}
      sx={{
        marginX: 'auto',
        marginBottom: 3,
        backgroundColor: 'white',
        padding: 1,
        borderRadius: 2,
        maxWidth: { xs: 'calc(100vw - 128px)', sm: 350 },
        maxHeight: { xs: 96 },
      }}
    />
  );
};

export default Hero;
